export default __webpack_public_path__ + "static/media/play.b9da49cb.png";